import { Skeleton, Stack, Typography } from "@mui/material";
import useGetTenantsHistory from "../../../hooks/tenants/get-tenants-history";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import CommonBottomSheet from "@/modules/common/components/ui-kit/bottom-sheets/common-bottom-sheet";
import { Contract } from "../../../dtos/tenants";
import ModalHeader from "@/modules/common/components/ui-kit/modals/modal-header";
import { TenantContractEntry } from "./tenant-contract-entry";
import CommonModal from "@/modules/common/components/ui-kit/modals/common-modal";

const TenantHistoryContent = ({ propertyUid }: { propertyUid: string }) => {
  const { data: tenantsHistory, isFetching } = useGetTenantsHistory({
    propertyUid,
  });
  if (isFetching) {
    return <Skeleton />;
  }

  if (tenantsHistory?.length === 0) {
    return <Typography>No tenants history found</Typography>;
  }
  return (
    <Stack p={(theme) => theme.nawy.spacing.md} overflow="auto" width="100%">
      {tenantsHistory?.map((tenant: Contract) => (
        <TenantContractEntry key={tenant.uid} tenantContract={tenant} />
      ))}
    </Stack>
  );
};

function TenantsHistory({
  propertyUid,
  open,
  handleClose,
}: Readonly<{
  propertyUid: string;
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}>) {
  const { isMobile } = useScreenSize();
  if (isMobile) {
    return (
      <CommonBottomSheet isOpen={open} onClose={handleClose}>
        <ModalHeader title="Tenants History" onClose={handleClose} />
        <TenantHistoryContent propertyUid={propertyUid} />
      </CommonBottomSheet>
    );
  } else
    return (
      <CommonModal
        title="Tenants History"
        open={open}
        onClose={handleClose}
        sx={{ width: 480 }}
      >
        <TenantHistoryContent propertyUid={propertyUid} />
      </CommonModal>
    );
}

export default TenantsHistory;
